
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Point, Size } from "../../../../domain/drawing";
import { ModelEditableMixin } from "../../../system/mixins";
import {
  IOffsetInformation,
} from "../IOffsetInformation";
import DocumentStructureEditableMixin from "./DocumentStructureEditableMixin.vue";

@Component
export default class DocumentPageEditorContextMenuMixin extends Mixins(ModelEditableMixin, DocumentStructureEditableMixin) {
  @Prop()
  pageSize: Size;

  @Prop({ default: 1 })
  scale: number;

  @Prop()
  getOffset: () => IOffsetInformation;
  
  data(): any {
    return {
      size: new Size(0, 0),
      location: null,
    };
  }
  size: Size;
  location: Point;

  updateLocation(event: PointerEvent): void {
    const offset = this.getMenuOffset();
    this.location = (new Point(
      event.clientX + offset.scrollLeft - offset.left,
      event.clientY + offset.scrollTop - offset.top
    ))
    .multiply(1 / this.scale);
  }

  getMenuOffset(): IOffsetInformation {
    const offset = this.getOffset ? this.getOffset() : null;
    return offset
      ? offset
      : {
        top: 0,
        left: 0,
        scrollTop: 0,
        scrollLeft: 0,
      };
  }

  updateSize(): void {
    this.size = this.visibleMinSize;  // 表示されるまではサイズが取れないので、表示される最低サイズに一旦更新しておく.
    this.$nextTick(() => {
      // サイズは表示してからじゃないと取れないのでここで更新.
      this.size = this.getSize();
    });
  }

  get isVisibleSize(): boolean {
    return (this.emptyThresholdSize.width < this.size.width)
        && (this.emptyThresholdSize.height < this.size.height);
  }

  get visibleMinSize(): Size {
    return new Size(this.emptyThresholdSize.width + 1, this.emptyThresholdSize.height + 1);
  }

  // サイズによるメニューのコンテンツ有無判定の閾値.(スタイル変更する場合は値に注意する事.)
  get emptyThresholdSize(): Size {
    return new Size(15, 15);
  }

  get isOriginTop(): boolean {
    // 可変でページ分割される状態でページ下のほうのオブジェクトの右クリックメニューの表示位置がおかしくなってしまうので対策している。
    // ※#6960でページ範囲外にコンテキストメニューを表示させないようにした修正が可変に対応できていなかったが、#7164で暫定対応したのち、その後本対応している。
    return !this.location || (this.pageSize.height < this.location.y) || (this.pageSize.height - this.location.y) > this.size.height;
  }

  get geometryProperties(): any {
    return this.location
      ? {
        position: "absolute",
        top: this.isOriginTop ? this.location.y - 10 + "px" : undefined,
        bottom: this.isOriginTop ? undefined : this.pageSize.height - this.location.y - 10 + "px",
        left: this.location.x - 10 + "px",
      }
      : null;
  }

  getSize(): Size {
    return this.$refs.root
      ? new Size((this.$refs.root as HTMLDivElement).clientWidth, (this.$refs.root as HTMLDivElement).clientHeight)
      : new Size(0, 0);
  }
}
